import React from "react";
import BreadcrumbComponent from "../../components/Common/BreadcrumbComponent";
import SiteSearchResult from "../../components/SiteSearch/SiteSearchResult";
import Footer from "../../components/_App/Footer";
import Header from "../../components/_App/Header";
import apiClient from "../../data/apiClient";
import { GLOBAL_SEARCH_QUERY } from "../../data/globalSearchQuery";
import { FOOTER_QUERY } from "../../data/pageQuery";
import Link from "next/link";

function SiteSearch({ slug, menu, footer, data, inputVal }) {
  const breadcrumb = {
    breadcrumbs: [{ title: "Site Search", link: "/sitesearch/-" }],
  };

  return (
    <>
      <Header {...menu} />
      <div className='page-wrapper flex-grow-1'>
        <BreadcrumbComponent {...breadcrumb} />
        <br />
        <div className='text-center text-muted'>
          If you are looking for product catalogue search click &nbsp;
          <Link href='/search/-/-' legacyBehavior>
            <a>here</a>
          </Link>
        </div>
        <SiteSearchResult data={data} slug={slug} defaultValue={inputVal} />
      </div>
      <Footer {...footer} />
    </>
  );
}

export default SiteSearch;

export async function getServerSideProps({ params }) {
  const { slug = "" } = params;
  let notFound = false;
  notFound = slug === "";

  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const filter = isAU ? "data/isAU/iv eq true" : "data/isNZ/iv eq true";

  try {
    const { data } = await(await apiClient()).query({
      query: FOOTER_QUERY,
      variables: {},
      fetchPolicy: "cache-first",
    });

    const {
      queryFooterContents: footerContents,
      queryMenuContents: menuContents,
    } = data;

    const footerContent =
      footerContents[0] != null ? footerContents[0].flatData : [];
    const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

    const processedString = replaceSpecialChars(slug);

    if (slug !== "-") {
      const { data: searchResult } = await(await apiClient()).query({
        query: GLOBAL_SEARCH_QUERY,
        variables: {
          search: processedString,
          filter: filter,
        },
        fetchPolicy: "no-cache",
      });

      return {
        props: {
          slug: params.slug,
          footer: footerContent,
          menu: menuContent,
          inputVal: processedString,
          data: searchResult,
          seo: {
            title: `Ryco Site Search`,
            metadata: `Search Ryco Products and Other Informations`,
            keywords: "Ryco Site Search",
            pic: null,
            socialTitle: `Site Search | Ryco Filters`,
          },
        },
      };
    } else {
      return {
        props: {
          slug: "-",
          footer: footerContent,
          menu: menuContent,
          inputVal: processedString,
          data: [],
          seo: {
            title: `Ryco Site Search`,
            metadata: `Search Ryco Products and Other Informations`,
            keywords: "Ryco Site Search",
            pic: null,
            socialTitle: `Site Search | Ryco Filters`,
          },
        },
      };
    }
  } catch (error) {
    console.log("page loading error", error);
  }
}

const replaceSpecialChars = (string) => {
  return string
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9\s]+/g, "")
    .replace(/\s+/g, "-");
};
